export default __webpack_public_path__ + "static/media/APEX-CAPITAL_2.5f043421.svg";